import React, { useEffect, useState } from "react";
import { Chip, MenuItem } from "@mui/material";
import { Delete } from "@/icons";
import { useContributorsState } from "@/store";
import { CCUsersContainer,
    StyledTextField,
    DropdownMenu,
    ChipsContainer,
 } from "./CCUsersComponent.elements";

const haveSameSelectedUsers = (left, right) => {
  if (left.length !== right.length) {
    return false;
  }

  return left.every((user, index) => {
    const otherUser = right[index];
    return user?.id === otherUser?.id && user?.email === otherUser?.email && user?.name === otherUser?.name;
  });
};

const CCUsersComponent = ({ onCCUpdate, selectedEmails = [] }) => {
  const { contributors = [] } = useContributorsState();
  const [selectedCC, setSelectedCC] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    if (!selectedEmails.length) {
      setSelectedCC([]);
      return;
    }

    const contributorsByEmail = new Map(contributors.map((user) => [user.email, user]));
    const nextSelectedCC = selectedEmails.map(
      (email) => contributorsByEmail.get(email) || { id: email, name: email, email }
    );
    setSelectedCC((currentSelectedCC) =>
      haveSameSelectedUsers(currentSelectedCC, nextSelectedCC) ? currentSelectedCC : nextSelectedCC
    );
  }, [contributors, selectedEmails]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Filter users based on the search term
    const filtered = contributors.filter(
      (user) =>
        // user.role === "manager" &&
        (user.name.toLowerCase().includes(value.toLowerCase()) ||
        user.email.toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredUsers(filtered);
  };

  const handleAddCC = (user) => {
    if (selectedCC.length < 5 && !selectedCC.some((cc) => cc.id === user.id)) {
      const updatedCC = [...selectedCC, user];
      setSelectedCC(updatedCC);
      onCCUpdate(updatedCC.map((cc) => cc.email));
      setSearchTerm("");
      setFilteredUsers([]);
    }
  };

  const handleRemoveCC = (user) => {
    const updatedCC = selectedCC.filter((cc) => cc.id !== user.id);
    setSelectedCC(updatedCC);
    onCCUpdate(updatedCC.map((cc) => cc.email));
  };

  return (
    <CCUsersContainer>
      <StyledTextField
        label="Add CC"
        placeholder="Search and add users"
        variant="outlined"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      {searchTerm && filteredUsers.length > 0 && (
        <DropdownMenu>
          {filteredUsers.map((user) => (
            <MenuItem
              key={user.id}
              onClick={() => handleAddCC(user)}
              disabled={selectedCC.some((cc) => cc.id === user.id)}
            >
              {user.name} - {user.email}
            </MenuItem>
          ))}
        </DropdownMenu>
      )}
      <ChipsContainer>
        {selectedCC.map((cc) => (
          <Chip
            key={cc.id}
            label={`${cc.name} (${cc.email})`}
            onDelete={() => handleRemoveCC(cc)}
            deleteIcon={<Delete />}
          />
        ))}
      </ChipsContainer>
    </CCUsersContainer>
  );
};

export default CCUsersComponent;
